import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoginForm } from './login/login-form';
import { RegisterForm } from './register/register-form';

@Component({
  selector: 'app-login-component',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    LoginForm,
    RegisterForm,
  ],
  templateUrl: './login-dialog.html',
  styleUrl: './login-dialog.scss',
  standalone: true
})
export class LoginDialogComponent {
  protected isRegisterMode = false;
  protected loading = false;
  protected redirectUrl?: string;

  constructor(
    private ref: DynamicDialogRef,
    protected config: DynamicDialogConfig
  ) {
    // Get redirectUrl from dialog config
    this.redirectUrl = this.config.data?.redirectUrl;
  }

  switchMode(): void {
    this.isRegisterMode = !this.isRegisterMode;
  }

  close(): void {
    this.ref.close();
  }

  onSuccess(): void {
    this.ref.close({
      success: true,
      redirectUrl: this.redirectUrl
    });
  }
}
